export const defaultOptionValue = '_DEFAULT';
export const allOptionValue = '_ALL';
